/**
 * Copyright 2019 AutoZone, Inc.
 * Content is confidential to and proprietary information of AutoZone, Inc., its
 * subsidiaries and affiliates.
 */
import React from 'react';
import Skeleton from '../../../Skeleton/Skeleton';
import styles from './RightSection.module.scss';
import { useLocale } from '@/hooks/useLocale';
import { countryCodes } from '@/constants/locale';
import CalmBoxStepperSkeleton from '@/features/cart/components/QuantityStepper/CalmBoxStepperSkeleton';

const DeliveryOption = ({ className }: { className?: string }) => {
  return (
    <div className={`${styles.skeletonDeliverOptionContainer} ${className || ''}`}>
      <div className={styles.skeletonDeliverOptionCircle} />
      <Skeleton animation="wave" width={212} height={20} variant="rect" />
    </div>
  );
};

const Right = () => {
  const locale = useLocale();
  const isMxSite = locale === countryCodes.mx;
  const isBR = locale === countryCodes.ptBr;

  return (
    <div className={styles.container}>
      <Skeleton animation="wave" width="90%" height={22} variant="rect" />
      <Skeleton
        className={styles.skeletonMargin}
        animation="wave"
        width="15%"
        height={12}
        variant="rect"
      />
      <Skeleton
        className={styles.skeletonMargin}
        animation="wave"
        width="25%"
        height={16}
        variant="rect"
      />

      <div className={styles.skeletonPartGrid}>
        <Skeleton
          className={styles.skeletonMargin}
          animation="wave"
          width="25%"
          height={16}
          variant="rect"
        />

        <Skeleton
          className={styles.skeletonMargin}
          animation="wave"
          width="25%"
          height={16}
          variant="rect"
        />
      </div>
      <Skeleton
        className={styles.skeletonMargin}
        animation="wave"
        width="60%"
        height={25}
        variant="rect"
      />

      <Skeleton
        className={styles.skeletonFitsYourVehicle}
        animation="wave"
        width="100%"
        height={40}
        variant="rect"
      />
      <hr className={styles.horizontalSpacing} />

      {!isMxSite ? (
        <div className={styles.skeletonSplitSquares}>
          <Skeleton
            className={styles.skeletonMargin}
            animation="wave"
            width="33%"
            height={75}
            variant="rect"
          />
          <Skeleton
            className={styles.skeletonMargin}
            animation="wave"
            width="33%"
            height={75}
            variant="rect"
          />
          <Skeleton
            className={styles.skeletonMargin}
            animation="wave"
            width="33%"
            height={75}
            variant="rect"
          />
        </div>
      ) : (
        <>
          <DeliveryOption />
          <DeliveryOption className={styles.skeletonDeliverOptionSecondItem} />
        </>
      )}

      {!isBR ? (
        <div className={styles.skeletonProductActions}>
          <CalmBoxStepperSkeleton
            stepperWithUnitPriceClassName={styles.skeletonStepper}
            rootWrapperClassName={styles.skeletonStepper}
            buttonGroupClassName={styles.skeletonStepperContainer}
          />
          <div className={styles.skeletonAddToCartButton}></div>
        </div>
      ) : null}
    </div>
  );
};

export default Right;
